import React from "react";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlidePage1 from "./SlidePage1";
import SlidePage2 from "./SlidePage2";
import SlidePage3 from "./SlidePage3";
import { useNavigate } from "react-router-dom";

const SliderBox = () => {
 const navigate=useNavigate();

  let settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidersToShow: 1,
    slidersToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };


  const navigateHome=()=>{
navigate('/home');
  }

  return (
    <>
    <div className="w-full lg:w-8/12 md:w-9/12 relative shadow-lg">

        <button onClick={navigateHome} type="button" className="z-10 absolute right-0 -top-2  text-white bg-gray-700 hover:bg-gray-800 focus:ring-1 focus:outline-none focus:ring-gray-300 font-sm rounded-md px-3 py-1 text-sm  text-center inline-flex items-center ">
    Skip
    <svg className="w-5 h-5 ml-2 -mr-1 animate-forward" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
</button>
    <div className="w-full   pb-7 overflow-hidden ">

<Corousel {...settings}>
  <Wrap>
    <SlidePage1 />
  </Wrap>
  <Wrap>
    <SlidePage2 />
  </Wrap>
  <Wrap>
    <SlidePage3 />
  </Wrap>
</Corousel>
</div>
    </div>
      
    </>
  );
};

const Corousel = styled(Slider)`
  margin-top: 0px;
  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;

    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }

  ul li button {
    &:before {
      font-size: 12px;
      color: gray;
    }
  }

  .slick-list {
    overflow: initial;
  }
  .slick-prev {
    left: 0px;
  }
  .slick-next {
    right: 0px;
  }
`;

const Wrap = styled.div`
border-radius:4px;

position:relative;
width:100%:

`;

export default SliderBox;
